"use client";
import React from "react";
import { Button } from "@chakra-ui/react";
import { LucideIcon } from "lucide-react";

interface ActionButtonProps {
  label: React.ReactNode;
  icon?: LucideIcon | React.ElementType;
  onClick?: () => void;
  isDisabled?: boolean;
  iconPosition?: "left" | "right";
  size?: "sm" | "md" | "lg";
  // Add variant prop: 'primary' for blue, 'outline' for Kleer white
  variant?: "primary" | "outline"; 
  [key: string]: any;
}

export default function ActionButton({
  label,
  icon: Icon,
  onClick,
  isDisabled = false,
  iconPosition = "left",
  size = "md",
  variant = "primary", // Default primary blue
  ...rest
}: ActionButtonProps) {
  const iconProps = Icon
    ? iconPosition === "left"
      ? { leftIcon: <Icon size={16} /> }
      : { rightIcon: <Icon size={16} /> }
    : {};

  // Define styles based on variant
  const variantStyles = variant === "primary" 
    ? {
        bg: "#2e3e7a",
        color: "white",
        _hover: { bg: "#1F305E" },
      }
    : {
        bg: "white",
        color: "#2e3e7a",
        border: "1px solid",
        borderColor: "#2e3e7a",
        _hover: { bg: "blue.50" },
      };

  return (
    <Button
      {...iconProps}
      {...variantStyles} // Apply the selected theme
      fontWeight="600"
      rounded="lg"
      isDisabled={isDisabled}
      onClick={onClick}
      size={size}
      {...rest}
    >
      {label}
    </Button>
  );
}